<template>
    <div class="row">
        <div class="col-12">
            <div class="card-header-actions">

              <div class="col-lg-6 col-md-8 col-12 card-header-filter-box">
                <div class="row align-items-end">
                  <div class="col-12 col-sm-6 card-header-search-box">
                    <div class="input-group">
                        <input class="form-control search-input" type="text" :placeholder="$t('main.search')" v-model="filter.search"
                               @keypress.enter="initList">
                        <div class="input-group-append">
                            <button class="all-btn search-btn" @click="initList">
                                <i class="fa fa-search"></i>
                            </button>
                        </div>
                    </div>
                  </div>
                  <div class="col-12 col-sm-6 card-header-select-box mt-2 mt-sm-0">
                    <div class="form-group">
                      <label style="color: grey">{{$t("common.status")}}</label>
                      <div class="position-relative">
                        <select class="form-control"
                                v-model="filter.status"
                                @change="onChangeVisibleState">
                            <option value=""></option>
                            <option value="ACTIVE">ACTIVE</option>
                            <option value="DEACTIVATED">DEACTIVATED</option>
                            <option value="DELETED">DELETED</option>
                        </select>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-lg-6 col-md-4 col-12 justify-content-md-end mt-md-0 mt-2 card-header-btns-box">
                <button class="all-btn add-btn m-0" @click="showPurposesRentingAreasAddEditModal(null)">
                  {{$t("action.add")}}
                </button>
              </div>

            </div>

        </div>
        <div class="col-12">
            <div class="table-wrapper">
              <table class="table">
                  <thead>
                  <tr>
                      <th>№</th>
                      <th>Номи</th>
                      <th>Актив</th>
                      <th class="text-center">{{$t("realEstate.field.action")}}</th>
                  </tr>
                  </thead>
                  <tbody v-if="!loading && results && results.data">
                  <tr v-for="result in results.data" :key="result.id">
                      <td>{{result.id}}</td>
                      <td>{{result.name}}</td>
                      <!--<td>{{result.active ? 'Ха' : 'Йўқ'}}</td>-->
                      <td>{{result.visibleState}}</td>
                      <td class="td-actions text-center">
                          <button class="all-btn edit-btn" data-original-title="Close"
                                  @click="purposeRentingAreasDeactivated(result.id)">
                              <i class="fa fa-close"></i>
                          </button>
                      </td>
                  </tr>
                  </tbody>
              </table>
            </div>
            <div class="text-center">
                <div class="loader mt-5 mb-5" v-if="loading"></div>
                <span class="no-data mt-5 mb-5" v-if="!loading && results && results.data && results.data.length===0">{{$t("messages.list.empty")}}</span>
            </div>
            <div class="row" v-if="!loading && results && results.total && results.total > 1 ">
                <div class="col-12 pt-3 pb-3">
                    <b-pagination :total-rows="results.total" v-model="filter.page.page" :per-page="filter.page.size"
                                  @change="onPageChange">
                    </b-pagination>
                </div>
            </div>
        </div>
        <PurposesRentingAreasAddEditModal/>
    </div>
</template>

<script>
    import bPagination from 'bootstrap-vue/es/components/pagination/pagination';
    import initFilterModel from '@/shared/filter';
    import PurposesRentingAreasAddEditModal from '@/views/config/rental_rates/PurposesRentingAreasAddEditModal';

    export default {
        name: "PurposesRentingAreasList",
        components: {
            'b-pagination': bPagination,
            PurposesRentingAreasAddEditModal: PurposesRentingAreasAddEditModal
        },
        data() {
            return {
                loading: false,
                filter: initFilterModel(),
                results: null,
            }
        },
        methods: {
            initList() {
                this.loading = true;
                this.$http.post('rental-rates/purposes-renting-areas/list', this.filter)
                    .then(res => {
                        this.results = res.data;
                        this.loading = false;
                    }, err => {
                        console.log(err);
                        this.loading = false;
                    });
            },

            purposeRentingAreasDeactivated(id) {
                const vm = this;
                this.loading = true;
                if (id) {
                    this.$http.get('rental-rates/purposes-renting-areas/deactivated/' + id)
                        .then(res => {
                            console.log(res.data);
                            window.location.reload();
                        }, (err) => {
                            console.log(err);
                            vm.loading = false;
                        });
                }

            },

            onPageChange(page) {
                this.filter.page.page = page;
                this.initList();
            },
            onChangeVisibleState() {
                this.filter.page.page = 1;
                this.initList()
            },
            showPurposesRentingAreasAddEditModal(data) {
                this.$eventBus.$emit('showPurposesRentingAreasAddEditModal', data);
            }
        },
        created() {
            this.initList();
            this.$eventBus.$on('purposesRentingAreasChanged', () => {
                this.initList();
            });
        }
    }
</script>

<style scoped>

</style>